export default from './SelectQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/SelectQuestion/index.js